/**
 * Session lockouts (Partner tier guide §9).
 *
 * Any request can return 403 with one of these while the user is signed in:
 *   "Partner is deactivated" · "Company is deactivated" · "User account is deactivated"
 * The UI then shows a full-page blocking screen (not a toast) and stops polling.
 * The session is kept, so "Try again" restores access once the partner/company/
 * user is reactivated. Platform admins never receive these.
 *
 * Both HTTP paths call `detectLockout` — the axios interceptor and the raw `fetch`
 * calls in streamingService — and announce a hit with `signalLockout`, which
 * PermissionsContext listens for.
 */

export const LOCKOUT_EVENT = 'rbac:lockout';

/**
 * @param {number} status
 * @param {object|null} body  parsed response body
 * @returns {'partner'|'company'|'user'|null}
 */
export const detectLockout = (status, body) => {
  if (status !== 403 || !body) return null;
  const text = (body.error || body.detail || body.message || '').toString();
  if (!/deactivated/i.test(text)) return null;
  if (/partner/i.test(text)) return 'partner';
  if (/company/i.test(text)) return 'company';
  return 'user';
};

export const signalLockout = (kind) => {
  try {
    window.dispatchEvent(new CustomEvent(LOCKOUT_EVENT, { detail: { kind } }));
  } catch (e) {
    /* no-op */
  }
};
